import { render } from "./TagFilter.vue?vue&type=template&id=58f2045f&scoped=true&ts=true"
import script from "./TagFilter.vue?vue&type=script&lang=ts"
export * from "./TagFilter.vue?vue&type=script&lang=ts"

import "./TagFilter.vue?vue&type=style&index=0&id=58f2045f&lang=scss&scoped=true"

import exportComponent from "/root/workspace/lll-ui_hccl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58f2045f"]])

export default __exports__